const e = e => new Intl.DateTimeFormat("en-US", e), a = {
    YearAndMonth: e({
        month: "long",
        year: "numeric"
    }),
    WeekDay: e({
        weekday: "short"
    }),
    WeekDayAbbr: e({
        weekday: "long"
    }),
    DayLabel: e({
        month: "long",
        day: "numeric",
        year: "numeric"
    }),
    Day: e({
        day: "numeric"
    })
};

export { a as default };
//# sourceMappingURL=formatters.js.map
